import React, {Fragment} from 'react';

import {
    SimpleForm,
    Edit,
    Create,
    ReferenceInput,
    SelectInput,
    TextInput,
    SaveButton,
    Toolbar,
    required
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import Avatar from "@material-ui/core/Avatar";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ComputerIcon from '@material-ui/icons/Computer';
import simpleMemoize from "../../framework/util/forms/SimpleMemoize";
import SitesStore from "../stores/SitesStore";
import StationsStore from "../stores/StationsStore";
import * as yup from "yup";
import PeopleStore from "../stores/PeopleStore";
import {yupValidate} from "../../framework/util/forms/YupValidationWithRFF";
import {setIn} from "final-form";


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

async function validateNameUnique(name) {

    let siteId = this.resolve(yup.ref('siteId'));
    const errors = {};
    const data = await new StationsStore().findAll();
    const list = data.data;
    var taken = false;
    for(let i = 0; i < list.length; i++){
        const site = list[i];
        if (site.name === name) {
            if (site.siteId === siteId) {
                taken = true;
                console.log('Station name is already taken: ', {name, site});
                break;
            }
        }
    }
    return new Promise((resolve, reject) => {
        if (taken)
            resolve(false);
        else
            resolve(true);
    })


};

const validationSchemaCreate = yup.object({
    name: yup.string().required().test('name', 'Name already exists at site', validateNameUnique),
    barcode: yup.string().required(),
    siteId: yup.string().required(),
    location: yup.string().required(),
    stationType: yup.string().required(),
});


// const validationSchemaCreate = yup.object().shape({
//     name: yup.string().required(),
//     barcode: yup.string().required(),
//     siteId: yup.string().required(),
//     location: yup.string().required(),
//     stationType: yup.string().required(),
// }).test('name', 'Name already exists', validateNameUnique);

const validationSchemaEdit = yup.object({
    barcode: yup.string().required(),
    siteId: yup.string().required(),
    location: yup.string().required(),
    stationType: yup.string().required(),
});



const SiteChooser = (props) => {
    return (
        <ReferenceInput
            label="Site"
            source="siteId"
            reference="site"
            variant='outlined'
            validate={required()}
            disabled={props.disabled}
        >
            <SelectInput
                helperText={'Site where station is located'}
                optionText={(record) => {
                    return record.id + ' - ' + record.name
                }}
            />
        </ReferenceInput>);
}

const IdChooser = (props) => {
    return (
        <TextInput
            label="Station Barcode"
            source="barcode"
            variant='outlined'
            helperText={'A unique barcode id for this station'}
        >
        </TextInput>);
}

const NameInput = (props) => {
    return (
        <TextInput
            label="Name"
            source="name"
            variant='outlined'
            validate={[required()]}
            helperText={'Name of device represented by this station.  Used to match work to this station, such as press jobs.'}
            disabled={props.disabled}
        >
        </TextInput>);
}

const LocationInput = (props) => {
    return (
        <TextInput
            label="Physical Location"
            source="location"
            variant='outlined'
            validate={required()}
            helperText={'Description of where this station is physically located on a site'}
        >
        </TextInput>);
}


const StationType = (props) => {
    return (
        <SelectInput label="Station Type" source="stationType"
                     variant='outlined' validate={required()}
                     helperText={'Type of station for example digital press, binding...'}
                     choices={[
                         {id: 'digitalPress', name: 'Digital Press'},
                         {id: 'cutting', name: 'Cutting'},
                         {id: 'binding', name: 'Binding'},
                     ]}/>);
}

const Header = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <ComputerIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
                Station Setup
            </Typography>
            <br/>
            <Typography component="h5">
                Configure station related settings. Once a station is configured, it can be adopted by a
                physical machine on the production floor.
            </Typography>
        </div>
    );
}

const FormContentsCreate = (props) => {
    return (
        <SimpleForm {...props} redirect="list"
                    validate={yupValidate(validationSchemaCreate)}
        >
            <NameInput/>
            <SiteChooser/>
            <LocationInput/>
            <StationType/>
            <IdChooser/>
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}

const FormContentsEdit = (props) => {
    return (
        <SimpleForm {...props} redirect="list"
                    validate={yupValidate(validationSchemaEdit)}
        >
            <NameInput disabled={true}/>
            <SiteChooser disabled={true}/>
            <LocationInput/>
            <StationType/>
            <IdChooser/>
            <RichTextInput source="notes" label={'Additional Notes'}/>
        </SimpleForm>
    );
}


const SaveAndAddToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            {...props}
            label="SAVE AND SHOW"
            redirect="show"
            submitOnEnter={true}
        />
        <SaveButton
            {...props}
            label="SAVE AND ADD"
            redirect={false}
            submitOnEnter={false}
            variant="text"
        />
    </Toolbar>
);


export const StationEditCommon = ({record, ...props}) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Edit {...props} title={(<span>Edit Station</span>)}>
                <FormContentsEdit {...props}/>
            </Edit>

        </div>
    );
}

const transformAddId = data => ({
    ...data,
    id: `${data.siteId} - ${data.name}`
});


export const StationCreateCommon = (props) => {
    const classes = useStyles();
    return (
        <div>
            <Header></Header>
            <Create {...props} title={(<span>Create New Station</span>)}
                    transform={transformAddId}
            >
                <FormContentsCreate {...props}/>
            </Create>

        </div>
    );
}

